import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AppRoutingService, SessionService } from '@ui-components/services';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environments/environment';
import { ConsentService, startMonitoring } from '@ui-components/consent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'owlhub-ollie';

  constructor(
    protected _app_routing_service: AppRoutingService,
    protected _cookie_service: CookieService,
    protected _session_service: SessionService,
    consent: ConsentService,
    ngZone: NgZone
  ) {
    consent.choice$.subscribe(choice => {
      if (choice === 'granted') {
        startMonitoring(environment.new_relic.ollie.applicationId, ngZone);
      }
    });
  }

  ngOnInit(): void {
    if (this._cookie_service.get('access_token')) {
      this._session_service.startIdleWatch();
    }
  }

  ngOnDestroy(): void {
    this._session_service.stopIdleWatch();
  }
  
  get homeUrl(): string {
    return this._app_routing_service.getAssessmentsUrl();
  }

  get settingsUrl(): string {
    return this._app_routing_service.getAssessmentsUrl('manage-account');
  }

  get profileUrl(): string {
    return this._app_routing_service.getAssessmentsUrl('profile');
  }

  get ollieUrl(): string {
    return this._app_routing_service.getOllieUrl();
  }

}
